/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-08-14 09:59:22
 * @LastEditors: linxi
 * @LastEditTime: 2024-04-19 11:04:46
 */

//医生业绩统计打印单
export function printDoctorAchievementBody(data: any) {
  const tenantName = data?.tenantName
  const timeHead = data?.timeHead
  const timeTail = data?.timeTail
  const categoryValue = data?.categoryValue // 0 默认，1 按处方分类
  const CKLRSJData = data?.CKLRSJData // 是否可查看成本/利润
  const datas = data?.dataList || []

  // 与页面汇总视图 DoctorAchievementColumns 保持一致的列
  const columns: any[] = [
    {
      title: '医生姓名',
      width: '10%',
      render: (r: any) => r?.treatmentDoctorName ?? '',
    },
    ...(categoryValue == 1
      ? [
          {
            title: '处方类型',
            width: '9%',
            render: (r: any) =>
              r?.categoryName == '合计' ? '' : (r?.categoryName ?? ''),
          },
        ]
      : []),
    {
      title: '处方数',
      width: '8%',
      render: (r: any) => r?.recipeCount ?? '',
    },
    {
      title: '人次',
      width: '6%',
      render: (r: any) => (categoryValue == 1 ? '-' : (r?.personTime ?? '')),
    },
    {
      title: '人均',
      width: '7%',
      render: (r: any) =>
        categoryValue == 1 ? '-' : (r?.personTimeAvgAmount?.toFixed(2) ?? ''),
    },
    {
      title: categoryValue == 1 ? '处方总费用' : '总费用',
      width: categoryValue == 1 ? '11%' : '9%',
      render: (r: any) => r?.totalPayAmount?.toFixed(2) ?? '',
    },
    ...(categoryValue == 1
      ? []
      : [
          {
            title: '应收总金额',
            width: '11%',
            render: (r: any) => r?.shoudPayAmount?.toFixed(2) ?? '',
          },
        ]),
    {
      title: '实收金额',
      width: '9%',
      render: (r: any) =>
        categoryValue == 1 ? '-' : (r?.realPayAmount?.toFixed(2) ?? ''),
    },
    {
      title: '医保报销金额',
      width: '12%',
      render: (r: any) =>
        categoryValue == 1 ? '-' : (r?.totalInsurancePayAmount?.toFixed(2) ?? ''),
    },
    {
      title: '成本总金额',
      width: '11%',
      render: (r: any) => (!CKLRSJData ? '***' : (r?.totalCost?.toFixed(2) ?? '')),
    },
    {
      title: '利润',
      width: '8%',
      render: (r: any) => (!CKLRSJData ? '***' : (r?.profit?.toFixed(2) ?? '')),
    },
    {
      title: '利润率',
      width: '9%',
      render: (r: any) => (!CKLRSJData ? '***' : (r?.profitRate ?? '')),
    },
  ]

  const cell = (value: any, w: string, isLast: boolean, extra = '') =>
    `<div style="line-height:25px;padding-left:2px;padding-right:2px;word-break:break-all;width:${w};text-align:center;box-sizing:border-box;${isLast ? '' : 'border-right:1px solid #000'}${extra}">${value}</div>`

  // 表头
  const headerHtml = columns
    .map((c, i) => cell(c.title, c.width, i === columns.length - 1))
    .join('')

  // 数据行（dataList 中已包含“合计”行）
  let rowHtml = ''
  for (const r of datas) {
    const extra = ''
    const cells = columns
      .map((c, i) => cell(c.render(r), c.width, i === columns.length - 1))
      .join('')
    rowHtml +=
      `<div style="min-height:28px;font-size:13px;display:flex;clear:left;border-left:1px solid #000;border-right:1px solid #000;border-bottom:1px solid #000${extra}">` +
      cells +
      '</div>'
  }

  const timeHeadText = (timeHead || '').toString().split(' ')[0]
  const timeTailText = (timeTail || '').toString().split(' ')[0]

  const content =
    '<div style="margin-left:10px;margin-right:10px">' +
    `<h3 style="text-align:center;margin-bottom:5px;">${tenantName}</h3>` +
    '<h3 style="text-align:center;margin-top:5px;margin-bottom:5px;">医&nbsp;&nbsp;生&nbsp;&nbsp;业&nbsp;&nbsp;绩&nbsp;&nbsp;统&nbsp;&nbsp;计</h3>' +
    '<div style="font-size:14px;display:flex;text-align:left;margin-bottom:6px">' +
    `<div style="font-size:14px;width:100%;padding-left:10px;display:flex;justify-content:flex-end;">日期:<font style="font-size:14px;word-break:break-all;padding-left:10px">${timeHeadText}至${timeTailText}</font></div>` +
    '</div>' +
    `<div style="font-weight:bold;min-height:25px;line-height:25px;font-size:14px;display:flex;clear:left;border:1px solid #000">${headerHtml}</div>` +
    rowHtml +
    '</div>'

  return content
}
